<div class="container pt-2">
  <div class="madar--v2">
    <mat-card class="mat-elevation-z4 mb-3 card__layout raduis-2" *ngIf="showBreadcrumb">
      <mat-card-content class="my-2 px-2">
        <app-row justify="space-between" align="center" gutter="xs">
          <app-col cols="12" md="col">
            <div class="text">
              <div class="breadcrumb">
                <app-breadcrumb></app-breadcrumb>
              </div>
            </div>
          </app-col>
          <app-col cols="12" md="auto">
            <div class="action">
              <!-- Project trailing content here -->
              <ng-container *ngTemplateOutlet="trailingTemplate"></ng-container>
            </div>
          </app-col>
        </app-row>
      </mat-card-content>
    </mat-card>

    <div class="weight-semibold pb-3" *ngIf="!showBreadcrumb">
      <app-row justify="space-between" align="center" gutter="xs">
        <app-col cols="auto" md="auto">
          <div class="flex align-center">
            <ng-content select="[icon]"></ng-content>
            <p class="m-0 text-900 weight-medium h6">
              <ng-content select="[title]" class="flex align-center"></ng-content>
            </p>
          </div>
        </app-col>
        <app-col cols="12" md="auto">
          <div class="action">
            <!-- Project trailing content here -->
            <ng-container *ngTemplateOutlet="trailingTemplate"></ng-container>
          </div>
        </app-col>
      </app-row>
    </div>
  </div>

  <div class="page-content">
    <div class="content">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>

<!-- Define a template for the trailing content -->
<ng-template #trailingTemplate>
  <ng-content select="[trailing]"></ng-content>
</ng-template>
